import {
    Directive,
    ElementRef,
    Renderer2,
    AfterViewInit,
    HostListener
} from '@angular/core';

@Directive({
    selector: 'input:not([type=radio]):not([type=checkbox]), textarea'
})
export class MaterializeLabelFixDirective implements AfterViewInit {
    private label: HTMLElement | null = null;
    private input: HTMLInputElement;

    constructor(private el: ElementRef, private renderer: Renderer2) {
        this.input = this.el.nativeElement;
    }

    ngAfterViewInit() {
        this.findLabel();
        setTimeout(() => this.updateLabelState());
    }

    @HostListener('input')
    @HostListener('change')
    @HostListener('focus')
    @HostListener('blur')
    onEvent() {
        this.updateLabelState();
    }

    private findLabel() {
        const id = this.input.getAttribute('id');
        if (id) {
            const lbl = document.querySelector(`label[for="${id}"]`);
            if (lbl) {
                this.label = lbl as HTMLElement;

                return;
            }
        }

        const chipsContainer = this.findChipsContainer();
        if (chipsContainer) {
            const chipsId = chipsContainer.getAttribute('id');
            if (chipsId) {
                const lbl = document.querySelector(`label[for="${chipsId}"]`);
                if (lbl) {
                    this.label = lbl as HTMLElement;

                    return;
                }
            }
        }

        if (!chipsContainer) {
            const inputField = this.findInputFieldContainer();
            if (inputField) {
                const lbl = inputField.querySelector('label');
                if (lbl) {
                    this.label = lbl as HTMLElement;
                }
            }
        }
    }

    private updateLabelState() {
        if (!this.label) return;

        const value = this.input.value?.trim() || '';
        const hasValue = value.length > 0;
        const hasPlaceholder = !!this.input.getAttribute('placeholder');
        const isFocused = document.activeElement === this.input;
        const isDateInput = this.input.type === 'date';
        const chipsContainer = this.findChipsContainer();
        const hasChips = !!chipsContainer && chipsContainer?.querySelectorAll('.chip')?.length > 0;

        if (hasValue || hasPlaceholder || isFocused || hasChips || isDateInput) {
            this.renderer.addClass(this.label, 'active');
        } else {
            this.renderer.removeClass(this.label, 'active');
        }
    }

    private findChipsContainer(): HTMLElement | null {
        let parent: Node | null = this.input.parentNode;

        while (parent) {
            if (parent.nodeType === Node.ELEMENT_NODE) {
                const el = parent as HTMLElement;
                if (el.classList.contains('chips') || el.classList.contains('chips-field')) {
                    return el;
                }
            }
            parent = parent.parentNode;
        }

        return null;
    }

    private findInputFieldContainer(): HTMLElement | null {
        let parent: Node | null = this.input.parentNode;

        while (parent) {
            if (parent.nodeType === Node.ELEMENT_NODE) {
                const el = parent as HTMLElement;
                if (el.classList.contains('input-field')) {
                    return el;
                }
            }
            parent = parent.parentNode;
        }

        return null;
    }
}
